import React from 'react';
import clsx from 'clsx';
import { Icon, IconProps, Tag } from '@scale/scaleui';
import { OutlineStep, OutlineStepStatus } from './types';
import { faLock } from '@fortawesome/pro-regular-svg-icons';

type OutlineSectionStepProps = {
  step: OutlineStep;
  onClick?: () => void;
};

function getIconForStepStatus(status: OutlineStepStatus): IconProps['icon'] {
  switch (status) {
    case OutlineStepStatus.COMPLETED:
      return 'check';
    case OutlineStepStatus.IN_PROGRESS:
      return 'spinner-third';
    case OutlineStepStatus.NOT_STARTED:
    default:
      return faLock;
  }
}

export const OutlineSectionStep = ({ step, onClick }: OutlineSectionStepProps) => {
  return (
    <div
      className={clsx([
        'grid grid-flow-col items-center grid-cols-[auto_1fr_auto] gap-1',
        'w-full p-2',
        step.stepStatus === OutlineStepStatus.COMPLETED && 'cursor-not-allowed',
        step.stepStatus === OutlineStepStatus.NOT_STARTED && 'bg-neutral-100',
        step.stepStatus !== OutlineStepStatus.NOT_STARTED && 'cursor-pointer',
      ])}
      onClick={onClick && (() => onClick())}
    >
      <Icon icon={getIconForStepStatus(step.stepStatus)} size="sm" />
      <div className="flex gap-2 items-center text-xs text-neutral-700">
        {step.title}
        {step.stepType && <Tag>{step.stepType}</Tag>}
      </div>
      <div className="text-xs text-neutral-700">{step.timeEstimate}m</div>
    </div>
  );
};
